"use client";

import { AlertTriangle } from "lucide-react";

// Catches errors thrown in a root layout itself. With multiple root layouts (one per
// route group) there is no single app/layout.tsx to host a root error boundary, so a
// global-error must render its own <html>/<body>.
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <html lang="en">
      <body className="antialiased">
        <div className="flex min-h-screen items-center justify-center p-4">
          <div className="w-full max-w-lg overflow-hidden rounded-3xl border border-neutral-200 bg-white text-neutral-900 shadow-2xl">
            <div className="flex flex-col items-center justify-center gap-5 p-10 text-center">
              <AlertTriangle className="h-10 w-10 text-red-500" />
              <div className="space-y-2">
                <h1 className="text-lg font-semibold text-neutral-900">
                  Something went wrong!
                </h1>
                <p className="text-sm text-neutral-600">{error.message}</p>
              </div>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
